import { cp, http } from './http'
import Config from '../../config'

export { cp, http }
export default {

  authenticate() {
    let url = [Config.transports.cp.oauth, 'initialize'].join('');
    return cp.post(url, { redirect: window.location.href })
      .then((response) => {
        window.location = response.data.redirect;
      }).catch((error) => {
        // handle error
        console.error('bootstrap.api.authenticate failed with message: ', error.message);
      })
  },

  bootstrap() {
    let url = [Config.transports.cp.api, 'bootstrap', '?convert=1'].join('');

    return cp.get(url)
      .then(response => {
        return new Promise((resolve) => {
          let data = response.data;

          cp.defaults.baseURL = Config.transports.cp.api;
          cp.defaults.headers.common['X-CSRF-TOKEN'] = data.csrf_token;

          resolve(response);
        })
      });
  },

  keepAlive() {
    cp.get('keepalive')
      .then((response) => {
        cp.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf_token;
      }).catch((error) => {
        console.error('bootstrap.api.keepalive errored with message:', error.message)
      });
  },

  logout() {
    let url = [Config.transports.cp.oauth, 'forget'].join('');
    return oauth.post(url)
    .then(() => {
      document.location = '/'
    });
  },

  reset() {
    return new Promise((resolve, reject) => {
      let url = ['bootstrap', '?convert=1&reset=1'].join('');
      cp.get(url)
      .then(response => {
        let data = response.data;
        
        cp.defaults.baseURL = Config.transports.cp.api;
        cp.defaults.headers.common['X-CSRF-TOKEN'] = data.csrf_token;

        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  }
}
